import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import Grid from "@mui/material/Grid2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  createSalesOrder,
  getCustomer,
  getCustomermasterByCode,
  getProductCode,
  getSalesorderById,
  productCodeOption,
  salesOrderState,
  salesOrderStateMange,
  soTypeOption,
  todayallCustomerDropdown,
  todayCustomersDropdown,
  todayDateProducts,
  todayDateProductsDropdown,
  updateSalesOrder,
} from "../salesOrderData/salesOrderData";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";

import MaterialButton from "../../../../components/MaterialButton";
import { TbPencilPlus, TbTrash } from "react-icons/tb";
import { useLoading } from "../../../../context/LodingContext";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";

const SalesOrderForm = () => {
  const [salesOrderData, dispatch] = useReducer(
    salesOrderStateMange,
    salesOrderState
  );

  const [inputDisble, setInputDisble] = useState(false);
  const [customerOption, setCustomerOption] = useState([]);

  const [customerLoading, setCustomerLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [productOption, setProductOption] = useState([]);
  const [productSetInitialized, setProductSetInitialized] = useState(true);
  const { setCirleLoading } = useLoading();

  const { userId } = useAuthData();

  const navigate = useNavigate();
  const location = useLocation();
  const formType = location?.state?.type;
  const rowID = location?.state?.data?.id;

  useEffect(() => {
    fetchTodatCustomer();
    fetchTodayProduct();
  }, []);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
      setProductSetInitialized(false);
    } else if (formType == "edit") {
      setInputDisble(true);
      setProductSetInitialized(true);
    } else {
      setInputDisble(false);
      setProductSetInitialized(true);
    }
  }, [formType]);

  useEffect(() => {
    if (rowID) {
      fetchBySalesOrder();
    }
  }, [rowID]);

  const fetchBySalesOrder = async () => {
    try {
      const res = await request(BASEURL, getSalesorderById, {
        id: Number(rowID),
      });

      const data = res?.getSalesorder?.data[0];
      const selectedCustomerAddress =
        res?.getSalesorder?.selectedCustomerAddress;
      console.log(data, "data");

      const custName = data?.customer?.customerName || "";
      const custCode = data?.customer?.customerCode || "";
      dispatch({
        value: {
          value: data?.customer?.id,
          label: custName && custCode ? `${custName} (${custCode})` : custName,
          customerCode: custCode,
        },
        name: "customerName",
      });
      dispatch({
        value: {
          value: data?.orderType,
          label: data?.orderType,
        },
        name: "soType",
      });
      dispatch({
        value: data?.orderDate,
        name: "orderDate",
      });
      dispatch({
        value: data?.soNumber,
        name: "salesOrderId",
      });
      dispatch({
        value: data?.termsAndConditions,
        name: "terms",
      });
      dispatch({
        value: data?.totalAmount,
        name: "totalAmount",
      });
      dispatch({
        value: data?.discount,
        name: "discount",
      });
      dispatch({
        value: data?.grandTotal,
        name: "grandTotal",
      });
      dispatch({
        value: data?.customerAddress || "",
        name: "customerAddress",
      });

      const updatedProductDetails = data?.salesorderproductSet?.map(
        (product) => {
          const productCode = product?.product?.productCode;
          const productName = product?.product?.productName;
          const label =
            productName && productCode
              ? `${productName} (${productCode})`
              : productName || "";

          return {
            id: product?.id,
            itemName: {
              value: productCode,
              label: label,
              id: product?.product?.id,
            },
          calucualtedPrice: product?.price,
          uomType: { value: product?.uomType, label: product?.uomType },
          qty: product?.quantity,
          priceCode: {
            value: product?.priceCode,
            label: product?.priceCode,
          },
          productPrice: product?.amount,
          taxPercentage: Number(product?.tax),
          taxAmount: Number(product?.taxAmount),
          amount: Number(product?.totalAmount),

          itemNameStatus: "success",
          qtyStatus: "success",
          priceCodeStatus: "success",
          productPriceStatus: "success",
          taxPercentageStatus: "success",
          taxAmountStatus: "success",
          amountStatus: "success",
          uomTypeStatus: "success",
          calucualtedPriceStatus: "success",
        };
      }
    );

      dispatch({
        value: updatedProductDetails,
        name: "allProduct",
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (!productSetInitialized) return;

    const totalAmount = salesOrderData?.productDetails?.reduce((acc, cur) => {
      return acc + Number(cur?.amount || 0);
    }, 0);

    const totalProductAmount = salesOrderData?.productDetails?.reduce(
      (acc, cur) => acc + Number(cur?.productPrice || 0),
      0
    );

    const vatAmount = salesOrderData?.productDetails?.reduce(
      (acc, cur) => acc + Number(cur?.taxAmount || 0),
      0
    );

    dispatch({ value: totalAmount, name: "totalAmount" });
    dispatch({ value: totalProductAmount, name: "grandTotal" });
    dispatch({ value: vatAmount, name: "discount" });
  }, [salesOrderData?.productDetails, productSetInitialized]);

  const fetchTodatCustomer = () => {
    setCustomerLoading(true);
    request(BASEURL, todayCustomersDropdown)
      .then(async (res) => {
        const success = await res?.todayCustomersDropdown?.success;
        const data = await res?.todayCustomersDropdown?.data;

        if (success) {
          setCustomerOption(data);
        } else {
          setCustomerOption([]);
        }
      })
      .finally(() => {
        setCustomerLoading(false);
      });
  };

  const fetchTodayProduct = () => {
    setProductLoading(true);
    request(BASEURL, todayDateProductsDropdown)
      .then((res) => {
        setProductOption(res?.todayDateProductsDropdown?.data);
      })
      .finally(() => {
        setProductLoading(false);
      });
  };

  useEffect(() => {
    if (productOption?.length && salesOrderData?.productDetails?.length) {
      const needsUpdate = salesOrderData.productDetails.some((item) => {
        if (!item?.itemName) return false;
        const matched = productOption.find(
          (p) =>
            (item.itemName?.id && String(p?.id) === String(item.itemName.id)) ||
            (item.itemName?.value && String(p?.productCode) === String(item.itemName.value))
        );
        if (!matched?.productCode || !matched?.productName) return false;
        const expectedLabel = `${matched.productName} (${matched.productCode})`;
        return item.itemName?.label !== expectedLabel;
      });

      if (needsUpdate) {
        const updated = salesOrderData.productDetails.map((item) => {
          if (!item?.itemName) return item;
          const matched = productOption.find(
            (p) =>
              (item.itemName?.id && String(p?.id) === String(item.itemName.id)) ||
              (item.itemName?.value && String(p?.productCode) === String(item.itemName.value))
          );
          if (!matched?.productCode || !matched?.productName) return item;
          const expectedLabel = `${matched.productName} (${matched.productCode})`;
          return {
            ...item,
            itemName: {
              ...item.itemName,
              value: item.itemName.value || matched.productCode,
              label: expectedLabel,
              id: item.itemName.id || matched.id,
            },
          };
        });
        dispatch({ value: updated, name: "allProduct" });
      }
    }
  }, [productOption]);

  const handleAddNewForm = () => {
    dispatch({ type: "add" });
  };

  const handlePriceCodeChange = (e, s, i) => {
    dispatch({ value: e, name: s?.name, index: i });
  };

  const handleSelectCustomer = async (e, s) => {
    if (e) {
      dispatch({ value: "", name: "customerAddress" });
      try {
        const res = await request(BASEURL, getCustomer, { id: e?.value });

        const customerCoderes = await request(
          BASEURL,
          getCustomermasterByCode,
          {
            code: e?.customerCode,
          }
        );

        const customerData = customerCoderes?.getCustomermasterByCode?.data;
        const addressData = Array.isArray(customerData)
          ? customerData[0]?.addresses || []
          : customerData?.addresses || [];
        dispatch({
          value: addressData[0]?.address || "",
          name: "customerAddress",
        });

        const success = res?.getCustomer?.success;
        const data = res?.getCustomer?.customers[0]?.priceCode;
        dispatch({
          value: { value: data, label: data },
          allPricecode: true,
        });
      } catch (err) { }
    }
    dispatch({ value: e, name: s?.name });
  };

  const handleProductChange = async (e, s, i) => {
    if (e) {
      try {
        const res = await request(BASEURL, getProductCode, {
          productocde: e?.value.trim(),
        });
        const data = res?.getProductCode?.data;

        const newOption = [
          {
            value: "baseUom",
            label: data[0]?.baseUom,
          },
          {
            value: "productUom",
            label: data[0]?.productUom,
          },
        ];

        dispatch({
          value: newOption,
          name: "uomTypeOption",
          index: i,
        });
        dispatch({
          value: data[0]?.conversion,
          name: "conversation",
          index: i,
        });
        dispatch({
          value: data[0]?.vat,
          name: "taxPercentage",
          index: i,
        });

        const value = salesOrderData?.productDetails[i]?.priceCode?.label
          .toLowerCase()
          .trim();

        const amount = data[0][value];

        dispatch({
          value: amount,
          name: "calucualtedPrice",
          index: i,
        });
      } catch (err) { }
    } else if (!e) {
      dispatch({
        value: "",
        name: "originalproductPrice",
        index: i,
      });
      dispatch({
        value: "",
        name: "calucualtedPrice",
        index: i,
      });
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxPercentage",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxAmount",
        index: i,
      });
      dispatch({
        value: "",
        name: "uomType",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });
      dispatch({
        value: [],
        name: "uomTypeOption",
        index: i,
      });
      dispatch({
        value: "",
        name: "calucualtedPrice",
        index: i,
      });
    }

    dispatch({ value: e, name: s?.name, index: i });
  };

  const handleQuanityChange = (e, i) => {
    const value = e?.target?.value;

    const total =
      Number(value) *
      Number(salesOrderData?.productDetails[i]?.originalproductPrice);
    const totalPercentage =
      Number(salesOrderData?.productDetails[i]?.taxPercentage) * Number(value);
    const percentageAmount =
      (Number(salesOrderData?.productDetails[i]?.taxPercentage) / 100) *
      Number(total);

    const newTotal = Number(total || 0) + Number(percentageAmount || 0);
    if (value) {
      dispatch({
        value: value,
        name: "qty",
        index: i,
      });
      dispatch({
        value: percentageAmount,
        name: "taxAmount",
        index: i,
      });

      dispatch({
        value: total,
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: newTotal,
        name: "amount",
        index: i,
      });
      dispatch({
        value: total,
        name: "productPrice",
        index: i,
      });
    } else {
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });
      dispatch({
        value: "",
        name: "taxAmount",
        index: i,
      });
      dispatch({
        value: "",
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });
    }
  };

  const handleTaxChange = (e, i) => {
    const value = e?.target?.value;
    const taxamount =
      (Number(value) / 100) *
      Number(salesOrderData?.productDetails[i]?.productPrice);
    const amount =
      Number(taxamount) +
      Number(salesOrderData?.productDetails[i]?.totalAmountProduct);
    dispatch({
      value: value,
      name: "taxPercentage",
      index: i,
    });
    dispatch({
      value: taxamount,
      name: "taxAmount",
      index: i,
    });
    dispatch({
      value: amount,
      name: "amount",
      index: i,
    });
  };

  const handleDiscountChange = (e) => {
    const value = e?.target?.value;
    dispatch({
      value: value,
      name: "discount",
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    const isAllSuccess = salesOrderData?.productDetails?.every(
      (item) =>
        item.itemNameStatus === "success" &&
        item.qtyStatus === "success" &&
        item.priceCodeStatus === "success" &&
        item.productPriceStatus === "success" &&
        item.taxPercentageStatus === "success" &&
        item.taxAmountStatus === "success" &&
        item.amountStatus === "success"
    );

    if (
      isAllSuccess &&
      salesOrderData.soTypeStatus === "success" &&
      salesOrderData.orderDateStatus === "success" &&
      salesOrderData.customerNameStatus === "success" &&
      salesOrderData.customerAddressStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAdd = async () => {
    setCirleLoading(true);

    const renamedProductDetails = salesOrderData?.productDetails?.map(
      (item) => ({
        product: Number(item?.itemName?.id),
        uomType: item?.uomType?.label,
        quantity: item?.qty,
        priceCode: item?.priceCode?.label,
        amount: String(item?.productPrice),
        tax: item?.taxPercentage,
        totalAmount: String(item?.amount),
        price: String(item?.calucualtedPrice),
        taxAmount: String(item?.taxAmount),
      })
    );

    try {
      const res = await request(BASEURL, createSalesOrder, {
        input: {
          user: userId,
          // sio: salesOrderData?.salesOrderId,
          customer: Number(salesOrderData?.customerName?.value),
          orderType: salesOrderData?.soType?.label,
          orderDate: salesOrderData?.orderDate,
          termsAndConditions: salesOrderData?.terms,
          discount: String(salesOrderData?.discount),
          totalAmount: String(salesOrderData?.totalAmount),
          status: "Pending",
          customerAddress: salesOrderData?.customerAddress,
          grandTotal: String(salesOrderData?.grandTotal),
          products: renamedProductDetails,
        },
      });

      const success = res?.createSalesOrder?.success;
      const message = res?.createSalesOrder?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/sales-order");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdate = async () => {
    setCirleLoading(true);
    const renamedProductDetails = salesOrderData?.productDetails?.map(
      (item) => ({
        id: item?.id,
        product: Number(item?.itemName?.id),
        uomType: item?.uomType?.label,
        quantity: item?.qty,
        priceCode: item?.priceCode?.label,
        amount: String(item?.productPrice),
        tax: item?.taxPercentage,
        totalAmount: String(item?.amount),
        price: String(item?.calucualtedPrice),
        taxAmount: String(item?.taxAmount),
      })
    );

    try {
      const res = await request(BASEURL, updateSalesOrder, {
        input: {
          // user: userId,
          salesOrderId: rowID,
          sio: salesOrderData?.salesOrderId,
          customer: Number(salesOrderData?.customerName?.value),
          orderType: salesOrderData?.soType?.label,
          orderDate: salesOrderData?.orderDate,
          teamsAndConditions: salesOrderData?.terms,
          discount: String(salesOrderData?.discount),
          totalAmount: String(salesOrderData?.totalAmount),
          status: "Pending",
          customerAddress: salesOrderData?.customerAddress,
          grandTotal: String(salesOrderData?.grandTotal),
          products: renamedProductDetails,
        },
      });

      const success = res?.updateSalesOrder?.success;
      const message = res?.updateSalesOrder?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/sales-order");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUomChange = (e, s, i) => {
    if (e) {
      dispatch({
        value: "",
        name: "uomType",
        index: i,
      });
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });

      dispatch({
        value: "",
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });

      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      if (e?.value == "productUom") {
        dispatch({
          value: salesOrderData?.productDetails[i]?.calucualtedPrice,
          name: "originalproductPrice",
          index: i,
        });
      } else if (e?.value == "baseUom") {
        const dived = salesOrderData?.productDetails[i]?.conversation;
        const price = salesOrderData?.productDetails[i]?.calucualtedPrice;

        const total = price / dived;

        dispatch({
          value: total,
          name: "originalproductPrice",
          index: i,
        });
      }
    } else {
      dispatch({
        value: "",
        name: "uomType",
        index: i,
      });
      dispatch({
        value: "",
        name: "qty",
        index: i,
      });

      dispatch({
        value: "",
        name: "totalAmountProduct",
        index: i,
      });
      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
      dispatch({
        value: "",
        name: "productPrice",
        index: i,
      });

      dispatch({
        value: "",
        name: "amount",
        index: i,
      });
    }
    dispatch({ value: e, name: s?.name, index: i });
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Sales Order Details"
                    : formType == "edit"
                      ? "Edit Sales Order Details"
                      : "View Sales Order Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              {inputDisble && (
                <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Sales Order Id <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={salesOrderData?.salesOrderId}
                    name="salesOrderId"
                    disabled
                    onChange={(e) =>
                      dispatch({
                        value: e?.target?.value,
                        name: "salesOrderId",
                      })
                    }
                    error={
                      salesOrderData.salesOrderIdStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      salesOrderData.salesOrderIdStatus === "success"
                        ? true
                        : false
                    }
                  />
                </Grid>
              )}
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerName"
                  value={salesOrderData?.customerName}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={customerOption?.map((item) => {
                    const name = item?.customerName || "";
                    const code = item?.customerCode || "";
                    return {
                      value: item?.id,
                      label: name && code ? `${name} (${code})` : name,
                      customerCode: code,
                    };
                  })}
                  onChange={(e, s) => handleSelectCustomer(e, s)}
                  error={
                    salesOrderData.customerNameStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.customerNameStatus === "success"
                      ? true
                      : false
                  }
                  isLoading={customerLoading}
                  isClearable
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Sales Order Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="soType"
                  value={salesOrderData?.soType}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={soTypeOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={salesOrderData.soTypeStatus === "error" ? true : false}
                  success={
                    salesOrderData.soTypeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Order Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  value={salesOrderData?.orderDate}
                  name="orderDate"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "orderDate" })
                  }
                  error={
                    salesOrderData.orderDateStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.orderDateStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 12, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Address<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialSelect
                 
                    multiline
                  rows={4}
                  value={salesOrderData?.customerAddress}
                  name="customerAddress"
                  isDisabled={inputDisble}
                  options={addressOptions}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={
                    salesOrderData.customerAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    salesOrderData.customerAddressStatus === "success"
                      ? true
                      : false
                  }
                /> */}
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={5}
                  value={salesOrderData?.customerAddress || ""}
                  name="customerAddress"
                  disabled={inputDisble}
                  onChange={(event) =>
                    dispatch({
                      value: event.target.value,
                      name: "customerAddress",
                    })
                  }
                  error={
                    salesOrderData.customerAddressStatus === "error" ? true : false
                  }
                  success={
                    salesOrderData.customerAddressStatus === "success" ? true : false
                  }
                  helperText={
                    salesOrderData.customerAddressStatus === "error"
                      ? "Please enter a valid address."
                      : ""
                  }
                  placeholder="Enter customer address"
                  size="small"
                />
              </Grid>
            </Grid>
            <Box sx={{ margin: "30px 0px" }}>
              {salesOrderData?.productDetails?.map((val, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      border: "solid 1px",
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "30px 0px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={{ lg: 12, xs: 5, sm: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ width: "90%" }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                Item Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                              name="itemName"
                              value={val?.itemName}
                              customStyles={{ optionPadding: 20 }}
                              isDisabled={
                                inputDisble
                                  ? true
                                  : salesOrderData?.customerName
                                    ? false
                                    : true
                              }
                              options={productOption?.map((item) => {
                                return {
                                  value: item?.productCode,
                                  label: item?.productName + ' (' + item?.productCode + ')',
                                  id: item?.id,
                                };
                              })}
                              onChange={(e, s) => handleProductChange(e, s, i)}
                              error={
                                val.itemNameStatus === "error" ? true : false
                              }
                              success={
                                val.itemNameStatus === "success" ? true : false
                              }
                              isLoading={productLoading}
                              isClearable
                            />
                          </Box>
                          {!inputDisble && (
                            <Box
                              sx={{
                                width: "10%",
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "10px",
                                marginTop: "25px",
                              }}
                            >
                              <TbPencilPlus
                                style={{
                                  fontSize: "45px",
                                  color: "white",
                                  fontWeight: "600",
                                  padding: "5px 10px",
                                  borderRadius: "50%",
                                  backgroundColor: "#2a9941",
                                }}
                                onClick={handleAddNewForm}
                              />
                              {i != 0 && (
                                <TbTrash
                                  style={{
                                    fontSize: "45px",
                                    color: "white",
                                    fontWeight: "600",
                                    padding: "5px 10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ff4d4f",
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    dispatch({ type: "delete", index: i })
                                  }
                                />
                              )}
                            </Box>
                          )}
                        </Box>
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Price Code <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="priceCode"
                          value={val?.priceCode}
                          customStyles={{ optionPadding: 20 }}
                          // isDisabled={
                          //   inputDisble ? true : val?.itemName ? false : true
                          // }
                          isDisabled={true}
                          options={productCodeOption?.map((item) => {
                            return {
                              value: item,
                              label: item,
                            };
                          })}
                          onChange={(e, s) => handlePriceCodeChange(e, s, i)}
                          error={val.priceCodeStatus === "error" ? true : false}
                          success={
                            val.priceCodeStatus === "success" ? true : false
                          }
                          isClearable
                        />
                      </Grid>

                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Price Code Amount{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Product Price"
                              : "Select Item Name"
                          }
                          value={val?.calucualtedPrice}
                          name="calucualtedPrice"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "calucualtedPrice",
                              index: i,
                            })
                          }
                          error={
                            val.calucualtedPriceStatus === "error"
                              ? true
                              : false
                          }
                          success={
                            val.calucualtedPriceStatus === "success"
                              ? true
                              : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            UOM Type <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="uomType"
                          value={val?.uomType}
                          customStyles={{ optionPadding: 20 }}
                          isDisabled={
                            inputDisble
                              ? true
                              : salesOrderData?.customerName
                                ? false
                                : true
                          }
                          options={val?.uomTypeOption?.map((item) => {
                            return {
                              value: item?.value,
                              label: item?.label,
                            };
                          })}
                          onChange={(e, s) => handleUomChange(e, s, i)}
                          error={val.uomTypeStatus === "error" ? true : false}
                          success={
                            val.uomTypeStatus === "success" ? true : false
                          }
                          isLoading={productLoading}
                          isClearable
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Qtn <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName ? "Enter Qtny" : "Select Item Name"
                          }
                          value={val?.qty}
                          name="qty"
                          disabled={
                            inputDisble ? true : val?.itemName ? false : true
                          }
                          onChange={(e) => handleQuanityChange(e, i)}
                          error={val.qtyStatus === "error" ? true : false}
                          success={val.qtyStatus === "success" ? true : false}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>

                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Product Price{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Product Price"
                              : "Select Item Name"
                          }
                          value={val?.productPrice}
                          name="productPrice"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "productPrice",
                              index: i,
                            })
                          }
                          error={
                            val.productPriceStatus === "error" ? true : false
                          }
                          success={
                            val.productPriceStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            VAT Percentage{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Tax Percentage"
                              : "Select Item Name"
                          }
                          value={val?.taxPercentage}
                          name="taxPercentage"
                          disabled={true}
                          onChange={(e) => handleTaxChange(e, i)}
                          error={
                            val.taxPercentageStatus === "error" ? true : false
                          }
                          success={
                            val.taxPercentageStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            VAT Amount <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          placeholder={
                            val?.itemName
                              ? "Enter Tax Amount"
                              : "Select Item Name"
                          }
                          value={val?.taxAmount}
                          name="taxAmount"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "taxAmount",
                              index: i,
                            })
                          }
                          error={val.taxAmountStatus === "error" ? true : false}
                          success={
                            val.taxAmountStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Amount <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="number"
                          value={val?.amount}
                          name="amount"
                          placeholder="Enter Product Code"
                          disabled={true}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "amount",
                              index: i,
                            })
                          }
                          error={val.amountStatus === "error" ? true : false}
                          success={
                            val.amountStatus === "success" ? true : false
                          }
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          sx={{
                            "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                            "& input": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Box>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Terms and condition
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={4}
                  value={salesOrderData?.terms}
                  name="customerAddress"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "terms" })
                  }
                  error={salesOrderData.termsstatus === "error" ? true : false}
                  success={
                    salesOrderData.termsstatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 9, xs: 5, sm: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "70px",
                  }}
                >
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Grand Total <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      value={salesOrderData?.grandTotal}
                      name="grandTotal"
                      disabled={true}
                      onChange={(e) =>
                        dispatch({
                          value: e?.target?.value,
                          name: "grandTotal",
                        })
                      }
                      error={
                        salesOrderData.grandTotalStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        salesOrderData.grandTotalStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total VAT Amount
                    </MaterialTypography>
                    <MaterialInput
                      type="number"
                      value={salesOrderData?.discount}
                      name="discount"
                      disabled={true}
                      onChange={(e) => handleDiscountChange(e)}
                      error={
                        salesOrderData.discountStatus === "error" ? true : false
                      }
                      success={
                        salesOrderData.discountStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>

                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total Amount <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                      value={salesOrderData?.totalAmount}
                      name="totalAmount"
                      disabled={true}
                      onChange={(e) =>
                        dispatch({
                          value: e?.target?.value,
                          name: "totalAmount",
                        })
                      }
                      error={
                        salesOrderData.totalAmountStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        salesOrderData.totalAmountStatus === "success"
                          ? true
                          : false
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  </MaterialBox>
                </Box>
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/sales-order")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdate}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default SalesOrderForm;
